<template>
  <el-row :gutter="20">
    <el-col :md="20">
      <el-input :value="value" @input="$emit('input', $event)" />
    </el-col>
    <el-col :md="4">
      <el-link
        :href="value"
        target="_blank"
        rel="noopener"
        :disabled="!value"
        :class="{ 'text-muted': !value }"
      >
        {{ $t("posts.components.otherMediasTestLink") }}
      </el-link>
    </el-col>
  </el-row>
</template>

<script>
/**
 * Switch entre plusieurs options avec possibilité d'annuler.
 */
export default {
  name: 'UbiInputUrl',
  props: {
    /**
     * La valeur actuellement choisie
     * @model
     */
    value: String
  }
}
</script>

<docs>
### Exemple

```jsx
let value = 'https://www.test.fr/';
<ubi-input-url v-model="value" />
```
</docs>
